import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 500
    }
  },
  image: {
    width: 40,
    height: 40,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.imageBorder.main}`,
    flexShrink: 0
  },
  name: {
    fontSize: '1.125em',
    fontWeight: 600,
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap'
  }
}))
